import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Sparkles, Save } from "lucide-react";
import { PILL, Input, TextareaField, Field } from "./shared";

export default function IdeaTab({ biz, setBiz }) {
  const [s, setS] = useState(biz.summary || {});
  const [saving, setSaving] = useState(false);
  const [regen, setRegen] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/business/summary", s);
      toast.success("Saved");
      setBiz({ ...biz, summary: s });
    } catch { toast.error("Failed"); }
    setSaving(false);
  };
  const regenerate = async () => {
    setRegen(true);
    try {
      const { data } = await api.post("/business/regenerate/summary");
      setBiz(data);
      setS(data.summary);
      toast.success("Regenerated");
    } catch { toast.error("Failed"); }
    setRegen(false);
  };
  const updateField = (k, v) => setS({ ...s, [k]: v });
  const updateServices = (idx, v) => setS({ ...s, services: s.services.map((x, i) => (i === idx ? v : x)) });

  return (
    <div>
      <div className="nb-card p-5 mb-6 flex items-center justify-between">
        <div className="font-display text-2xl font-extrabold">Your business idea</div>
        <div className="flex gap-2">
          <button onClick={regenerate} disabled={regen} className={`${PILL} bg-[#F5F0FF]`} data-testid="regen-idea-btn">
            {regen ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Regenerate
          </button>
          <button onClick={save} disabled={saving} className={`${PILL} bg-[#10B981] text-white`} data-testid="save-idea-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save
          </button>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Business name"><Input value={s.name || ""} onChange={(e) => updateField("name", e.target.value)} /></Field>
        <Field label="Business type"><Input value={s.type || ""} onChange={(e) => updateField("type", e.target.value)} /></Field>
        <div className="md:col-span-2"><Field label="One-sentence description"><TextareaField value={s.description || ""} onChange={(e) => updateField("description", e.target.value)} /></Field></div>
        <Field label="Main website goal"><Input value={s.goal || ""} onChange={(e) => updateField("goal", e.target.value)} /></Field>
        <Field label="Recommended CTA"><Input value={s.cta || ""} onChange={(e) => updateField("cta", e.target.value)} /></Field>
        <Field label="Suggested offer"><Input value={s.offer || ""} onChange={(e) => updateField("offer", e.target.value)} /></Field>
        <Field label="Brand style"><Input value={s.style || ""} onChange={(e) => updateField("style", e.target.value)} /></Field>
        <div className="md:col-span-2"><Field label="Services / products">
          <div className="space-y-2">
            {(s.services || []).map((svc, i) => (
              <Input key={i} value={svc} onChange={(e) => updateServices(i, e.target.value)} />
            ))}
          </div>
        </Field></div>
        <div className="md:col-span-2"><Field label="Suggested next step"><TextareaField value={s.next_step || ""} onChange={(e) => updateField("next_step", e.target.value)} /></Field></div>
      </div>
    </div>
  );
}
